import generateBasicEntityActions from "./generateBasicEntityActions";

const positionActions = generateBasicEntityActions(
  "clientPositions",
  "clientPosition"
);

export default positionActions;
